import React from "react";
import { useShoppingContext } from "../../../../context/ShoppingContext";
import AddGranjaForm from "../../Forms/AddFarmForm/AddGranjaForm";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSeedling } from "@fortawesome/free-solid-svg-icons";

const AddFarm = () => {
  const { setShowAddGranja, showAddGranja } = useShoppingContext();
  return (
    <div className="text-center">
      <button
        className={"btn btn-green w-100"}
        onClick={() => setShowAddGranja(!showAddGranja)}
      >
        <FontAwesomeIcon icon={faSeedling } />{" "}
        Crear Nueva Granja
      </button>
      {showAddGranja && <AddGranjaForm />}
    </div>
  );
};

export default AddFarm;
